import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=b996ede2&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=b996ede2&prod&lang=scss&scoped=true&"
import style1 from "./Index.vue?vue&type=style&index=1&id=b996ede2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b996ede2",
  null
  
)

export default component.exports